import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        var existing = document.getElementsByClassName('js-ticket-event');

        if (existing && existing.length && existing.length > 0) {
            return;
        }

        var blocks = document.getElementsByClassName('ticket-event');
        if (blocks && blocks.length && blocks.length > 1) {

            let newParent = document.createElement('div');
            newParent.className = 'scroll-shadow';

            var newNode = document.createElement('div');
            newNode.className = 'overflow-x-auto pt-5 pb-5 pl-5 bg-white flex space-x-5 js-ticket-event';

            newParent.appendChild(newNode);

            for (var i = 0; i < blocks.length; ++i) {
                var item = blocks[i];

                // Ugly quick fix after ticket event blocks getting other structures /JK
                var htmlString = '<div class="flex space-x-5 items-center"><div class="w-[160px] flex-none"><img class="grayscale group-hover:grayscale-0 group-focus:grayscale-0" src="';

                var image = item.dataset.ticketEventImg;
                if (image) {
                    htmlString += image;
                }
                else
                {
                    htmlString += 'https://cms.supporterklubben.se/cdn-cgi/image/w=960,h=540,f=auto/4a8c55/globalassets/svff/supporterklubben/mallgrafik/fallback-ticket-event.jpg';
                }

                htmlString += '" alt="" loading="lazy" width="960" height="540"></div><div class="min-w-[360px]"><h2 class="overflow-x-hidden font-trim text-supernova text-3xl whitespace-nowrap"><span class="hidden">Hoppa till </span>';

                var headlines = item.querySelectorAll(':scope .ticket-event__headline__splash .top');
                if (headlines && headlines.length > 0) {
                    htmlString += headlines[0].innerHTML;
                }

                htmlString += '</h2><p class="overflow-x-hidden font-trim text-supernova text-xl whitespace-nowrap">';

                var taglines = item.querySelectorAll(':scope .ticket-event__headline__splash .bottom');
                if (taglines && taglines.length > 0) {
                    htmlString += taglines[0].innerHTML;
                }

                htmlString += '</p></div></div>';

                var div = document.createElement('div');
                div.innerHTML = htmlString;
                var clone =  div.firstChild;

                // Set up anchor
                var anchorName = 'ticket-event-' + (i + 1);

                var newAnchor = document.createElement('a');
                newAnchor.setAttribute('name', anchorName);

                // Hack to snap correctly with sticky header
                newAnchor.className = 'block relative invisible -top-[3.125rem]';

                item.parentElement.insertBefore(newAnchor, item);

                var newLink = document.createElement('a');
                newLink.href = '#' + anchorName;
                newLink.setAttribute('data-turbo', 'false');
                newLink.className = 'flex flex-none focus:outline-supernova bg-prussian-blue hover:bg-congress-blue group';
                newLink.appendChild(clone);
                newNode.appendChild(newLink);
            }

            var newDummy = document.createElement('div');
            newDummy.className = 'w-[1px] bg-white';
            
            newNode.appendChild(newDummy);

            this.element.insertBefore(newParent, this.element.firstChild);
        }
    }
}
